<template>
  <div v-if="isCollaborator">
    <div class="pa-3" v-if="canConsultBet">
      <v-form v-on:submit="consultBet">
        <v-text-field
          v-model="betNumber"
          clearable
          append-icon="mdi-file-find-outline"
          v-on:click:append="showBetDialog(betNumber)"
          v-on:keydown="
            (e) => {
              if (e.key === 'Enter') showBetDialog(betNumber);
            }
          "
          :disabled="disableSearch"
          :label="$t('consultBet')"
          solo-inverted
          hide-details
          flat
          dense
        ></v-text-field>
      </v-form>
    </div>

    <template v-if="dashboard && hasDashboardPermission">
      <v-divider></v-divider>
      <v-list dense expand shaped>
        <v-list-item-group v-model="dashboard.meta.active">
          <v-list-item :to="{ name: dashboard.name }">
            <v-list-item-icon>
              <v-icon v-text="dashboard.meta.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="dashboard.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </template>

    <!-- Online -->
    <v-subheader v-if="showOnline" class="pr-0 overline">
      Online
      <v-divider class="ml-2"></v-divider>
    </v-subheader>
    <v-list dense expand shaped>
      <template v-for="item in onlineItems">
        <!-- NO GROUP -->
        <v-list-item-group
          v-if="!item.meta.group"
          :key="item.name"
          v-model="item.meta.active"
          class="mb-1"
          v-show="item.meta.operator"
        >
          <v-list-item :to="{ name: item.name }">
            <v-list-item-icon>
              <v-icon v-text="item.meta.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <!--GROUP -->
        <v-list-group
          v-if="item.meta.group && item.children.length > 0"
          :key="item.name"
          v-model="item.meta.active"
          :prepend-icon="item.action"
          no-action
          :class="item.meta.class"
          active-class
          :group="item.path"
          v-show="item.meta.operator"
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>{{ item.meta.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <template v-for="subItem in item.children">
            <v-list-item
              :key="subItem.meta.nameDrawer"
              exact
              :to="{ name: subItem.name }"
              v-if="
                !subItem.meta.hide
                && (
                  subItem.name === 'CollaboratorAffiliatesReports'
                  ? true
                  : $permission(subItem.meta.permission)
              )"
              v-show="subItem.meta.operator"
            >
              <v-list-item-content>
                <v-list-item-title v-text="subItem.meta.nameDrawer">
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
      </template>
    </v-list>

    <!-- Operação -->
    <v-subheader v-if="showNetwork" class="pr-0 overline">
      {{ $t("network") }}
      <v-divider class="ml-2"></v-divider>
    </v-subheader>
    <v-list dense expand shaped>
      <template v-for="item in networkItems">
        <!-- NO GROUP -->
        <v-list-item-group
          v-if="!item.meta.group"
          :key="item.name"
          v-model="item.meta.active"
          class="mb-1"
          v-show="item.meta.operator"
        >
          <v-list-item :to="{ name: item.name }">
            <v-list-item-icon>
              <v-icon v-text="item.meta.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <!--GROUP -->
        <v-list-group
          v-if="item.meta.group"
          :key="item.name"
          v-model="item.meta.active"
          :prepend-icon="item.action"
          no-action
          :class="item.meta.class"
          active-class
          :group="item.path"
          v-show="item.meta.operator"
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>{{ item.meta.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <template v-for="subItem in item.children">
            <v-list-item
              :key="subItem.meta.nameDrawer"
              exact
              :to="{ name: subItem.name }"
              v-if="!subItem.meta.hide"
              v-show="subItem.meta.operator"
            >
              <v-list-item-content>
                <v-list-item-title v-text="subItem.meta.nameDrawer">
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
      </template>
    </v-list>
    <!-- Operação -->
    <v-subheader v-if="showOperation" class="pr-0 overline">
      {{ $t("operation") }}
      <v-divider class="ml-2"></v-divider>
    </v-subheader>
    <v-list dense expand shaped>
      <template v-for="item in operationItems">
        <v-list-group
          :key="item.name"
          v-model="item.meta.active"
          :prepend-icon="item.action"
          no-action
          :class="item.meta.class"
          active-class
          :group="item.path"
          v-show="item.meta.operator"
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>{{ item.meta.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <template v-for="subItem in item.children">
            <v-list-item
              :key="subItem.meta.nameDrawer"
              exact
              :to="{ name: subItem.name }"
              v-if="!subItem.meta.hide"
            >
              <v-list-item-content>
                <v-list-item-title v-text="subItem.meta.nameDrawer">
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-for="subItem in item.children">
            <v-list-group
              class="ml-2"
              :key="subItem.meta.nameDrawer"
              sub-group
              v-if="subItem.meta.subGroup"
              v-show="item.meta.operator"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{
                    subItem.meta.nameDrawer
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-for="subItem in subItem.children">
                <v-list-item
                  v-if="$permission(subItem.meta.permission)"
                  class="ml-6"
                  exact
                  :key="subItem.meta.nameDrawer"
                  :to="{ name: subItem.name }"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="subItem.meta.nameDrawer">
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
        </v-list-group>
      </template>
    </v-list>

    <v-divider></v-divider>
    <div class="px-3 mb-5">
      <v-switch hide-details :label="$t('darkTheme')" v-model="dark"></v-switch>
    </div>
    <v-divider></v-divider>
    <BtnLanguages class="mt-4 px-4" />
  </div>
  <div style="margin-bottom: 190px" v-else>
    <div class="pa-3">
      <v-form v-on:submit="consultBet">
        <v-text-field
          v-model="betNumber"
          clearable
          append-icon="mdi-file-find-outline"
          v-on:click:append="showBetDialog(betNumber)"
          v-on:keydown="
            (e) => {
              if (e.key === 'Enter') showBetDialog(betNumber);
            }
          "
          :disabled="disableSearch"
          :label="$t('consultBet')"
          solo-inverted
          hide-details
          flat
          dense
        ></v-text-field>
      </v-form>
      <!-- <DialogConsultBet :data="dataConsultBet" /> -->
    </div>

    <!-- <v-subheader v-if="showRetail">
      Dashboard
      <v-divider class="ml-2" />
    </v-subheader> -->
    <template v-if="dashboard">
      <v-divider></v-divider>
      <v-list dense expand shaped>
        <v-list-item-group v-model="dashboard.meta.active">
          <v-list-item :to="{ name: dashboard.name }">
            <v-list-item-icon>
              <v-icon v-text="dashboard.meta.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="dashboard.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </template>

    <!--
    =======================================================================
    Operação Online
    =======================================================================
    -->
    <v-subheader v-if="showOnline" class="pr-0 overline"
      >Online
      <v-divider class="ml-2"></v-divider>
    </v-subheader>
    <v-list dense expand shaped>
      <template v-for="item in listOnline">
        <!-- NO GROUP -->
        <v-list-item-group
          v-if="!item.meta.group"
          :key="item.name"
          v-model="item.meta.active"
          class="mb-1"
          v-show="item.meta.operator"
        >
          <v-list-item :to="{ name: item.name }">
            <v-list-item-icon>
              <v-icon v-text="item.meta.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <!--GROUP -->
        <v-list-group
          v-if="item.meta.group"
          :key="item.name"
          v-model="item.meta.active"
          :prepend-icon="item.action"
          no-action
          :class="item.meta.class"
          active-class
          :group="item.path"
          v-show="item.meta.operator"
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>{{ item.meta.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <template v-for="subItem in item.children">
            <v-list-item
              :key="subItem.meta.nameDrawer"
              :exact="!$route.path.includes('affiliatesReports')"
              :to="{ name: subItem.name }"
              v-if="!subItem.meta.hide"
              v-show="subItem.meta.operator"
            >
              <v-list-item-content>
                <v-list-item-title v-text="subItem.meta.nameDrawer">
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
      </template>
    </v-list>

    <!--
    =======================================================================
    Operação Retail
    =======================================================================
    -->
    <v-subheader v-if="showRetail" class="pr-0 overline">
      {{ $t("network") }}
      <v-divider class="ml-2"></v-divider>
    </v-subheader>
    <v-list dense expand shaped>
      <template v-for="item in listRetail">
        <v-list-item-group
          v-if="!item.meta.group"
          :key="item.name"
          v-model="item.meta.active"
          class="mb-1"
          v-show="item.meta.operator"
        >
          <v-list-item :to="{ name: item.name }">
            <v-list-item-icon>
              <v-icon v-text="item.meta.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <!-- GROUP -->
        <v-list-group
          v-if="item.meta.group"
          :key="item.name"
          v-model="item.meta.active"
          :prepend-icon="item.action"
          no-action
          :class="item.meta.class"
          active-class
          :group="item.path"
          v-show="item.meta.operator"
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>{{ item.meta.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <template v-for="subItem in item.children">
            <v-list-item
              :key="subItem.meta.nameDrawer"
              exact
              :to="{ name: subItem.name }"
              v-if="!subItem.meta.hide"
              v-show="subItem.meta.operator"
            >
              <v-list-item-content>
                <v-list-item-title v-text="subItem.meta.nameDrawer">
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-for="subItem in item.children">
            <v-list-group
              :key="subItem.meta.nameDrawer"
              sub-group
              v-if="subItem.meta.subGroup"
              v-show="subItem.meta.operator"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="ml-2">{{
                    subItem.meta.nameDrawer
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                class="ml-8"
                exact
                v-for="subItem in subItem.children"
                :key="subItem.meta.nameDrawer"
                :to="{ name: subItem.name }"
                v-show="subItem.meta.operator"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.meta.nameDrawer">
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list-group>
      </template>
    </v-list>
    <!--
    =======================================================================
    Configurações
    =======================================================================
    -->
    <v-subheader v-if="showConfig" class="pr-0 overline"
      >{{ $t("operation") }}
      <v-divider class="ml-2"></v-divider>
    </v-subheader>
    <v-list dense expand shaped>
      <template v-for="item in listConfig">
        <v-list-group
          :key="item.name"
          v-model="item.meta.active"
          :prepend-icon="item.action"
          no-action
          :class="item.meta.class"
          active-class
          :group="item.path"
          v-show="item.meta.operator"
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon>{{ item.meta.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.meta.nameDrawer"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <template v-for="subItem in item.children">
            <v-list-item
              v-if="showMainEvents(subItem.name) && !subItem.meta.hide"
              :key="subItem.meta.nameDrawer"
              :to="{ name: subItem.name }"
              :exact="!$route.path.includes('invoices')"
            >
              <v-list-item-content>
                <v-list-item-title v-text="subItem.meta.nameDrawer">
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-for="subItem in item.children">
            <v-list-group
              :key="subItem.meta.nameDrawer"
              sub-group
              v-if="subItem.meta.subGroup"
              v-show="item.meta.operator"
            >
              <template v-slot:activator>
                <v-list-item-content class="pl-2">
                  <v-list-item-title>{{
                    subItem.meta.nameDrawer
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                class="pl-16"
                exact
                v-for="subItem in subItem.children"
                :key="subItem.meta.nameDrawer"
                :to="{ name: subItem.name }"
              >
                <v-list-item-content class="pl-6">
                  <v-list-item-title v-text="subItem.meta.nameDrawer">
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list-group>
      </template>
    </v-list>

    <!-- <v-list dense nav expand>
      <v-list-group
        v-for="item in items.children"
        :key="item.name"
        v-model="item.meta.active"
        :prepend-icon="item.action"
        no-action
        :class="item.meta.class"
        active-class
        :group="item.path"
      >
        
      </v-list-group>
    </v-list> -->
    <v-divider></v-divider>
    <div class="px-3 mb-5">
      <v-switch hide-details :label="$t('darkTheme')" v-model="dark"></v-switch>
    </div>
    <v-divider></v-divider>
    <BtnLanguages class="mt-4 px-4" />
  </div>
</template>

<script>
import RouterLocalManager from "@/router/backoffice/RouterLocalManager";
import RouterRegionalManager from "@/router/backoffice/RouterRegionalManager";
import RouterAdministrator from "@/router/backoffice/RouterAdministrator";
import RouterCollaborator from "@/router/backoffice/RouterCollaborator";
import BtnLanguages from "@/components/btn-languages/btn-languages";
// import DialogConsultBet from "./dialog";
export default {
  name: "drawerList",
  components: {
    BtnLanguages,
  },
  data: () => ({
    onlineItems: [],
    items: {
      children: "",
    },
    betNumber: "",
    dataConsultBet: [],
    dark: null,
    listOnline: [],
    listConfig: [],
    listRetail: [],
    showOnline: true,
    showRetail: true,
    showConfig: true,
    disableSearch: false,
    dashboard: null,
    allowedOnlineMenus: [],
    showOperation: true,
    operationItems: [],
    showNetwork: true,
    networkItems: [],
  }),
  mounted() {
    this.dark = this.$vuetify.theme.dark;

    const levels = {
      3: RouterLocalManager,
      4: RouterRegionalManager,
      6: RouterAdministrator,
      8: RouterCollaborator,
    };
    const { nivel } = this.$localStorage.getItem("user_data");
    this.items = levels[nivel];

    // Organização para Adminstrador
    // Faz o get dos dados no localStorage
    var operatorType = localStorage.getItem("operator-retail");
    var credit = localStorage.getItem("operator-credit");
    //Debugg
    // var operatorType = 2;
    // var credit = 2;
    // Arrays que serão inseridos em cada seção, conferência é realizada de acordo com o namedrawer
    let onlineItems = [
      `${this.$t("bets")} `,
      this.$t("affiliates"),
      this.$t("players"),
      this.$t("depositsAndWithdrawals"),
      this.$t("PromotionsAndbonus"),
      this.$t("casino"),
      `${this.$t("configuration")} `,
      "Dashboard",
      this.$t("documents"),
    ];
    const retailItems = [
      "Dashboard",
      this.$t("bets"),
      this.$t("credit"),
      this.$t("users"),
      this.$t("accountability"),
      this.$t("areas"),
      // Ger Local e Regional
      this.$t("accountDrawer"),
      // Ger Local  Regional
      this.$t("agents"),
    ];
    const configItems = [
      this.$t("reports"),
      this.$t("collaborators"),
      this.$t("events"),
      this.$t("configuration"),
      this.$t("system"),
      this.$t("account"),
      this.$t("actionsContributors"),
    ];

    // Para Adm
    this.items.children.map((item) => {
      onlineItems.map((online) => {
        if (
          (item.meta.nameDrawer == online && item.meta.typeDash == "online") ||
          (!item.meta.typeDash && item.meta.nameDrawer == online)
        ) {
          if (
            item.name === "RegionalManagerDashboard" ||
            item.name === "LocalManagerDashboard"
          )
            return;
          this.listOnline.push(item);
        }
      });
      configItems.map((configItems) => {
        if (item.meta.nameDrawer == configItems) {
          this.listConfig.push(item);
        }
      });
      retailItems.map((retailItems) => {
        if (
          (item.meta.nameDrawer == retailItems &&
            item.meta.typeDash == "retail") ||
          (!item.meta.typeDash && item.meta.nameDrawer == retailItems)
        ) {
          this.listRetail.push(item);
        }
      });
    });
    // Tratamento para sub-headers antes das seções
    // Remove subheaders para o Regional e Local
    if (nivel != 6) {
      // this.showOnline = false;
      this.showConfig = false;
    }
    if (credit == 1 || credit == 0) {
      this.showOnline = false;
    }
    if (operatorType == 0) {
      this.showRetail = false;
    }

    this.setDashboardDrawerData();

    if (this.isCollaborator) {
      this.setMenusCollaborator();
    }
  },
  watch: {
    dark(val) {
      this.$vuetify.theme.dark = val;
      localStorage.setItem("dark", val);
    },
  },

  computed: {
    showMainEvents() {
      return (route) => {
        if (route === "AdministratorMainEvents") {
          return (
            this.$store.state.operator &&
            this.$store.state.operator.main_events == "1"
          );
        }

        return true;
      };
    },
    isCollaborator() {
      const user_data = JSON.parse(localStorage.getItem("user_data"));
      return user_data.isCollaborator;
    },
    canConsultBet() {
      return this.$permission("22");
    },
    hasDashboardPermission() {
      return this.$permission("23");
    },
  },

  methods: {
    setDashboardDrawerData() {
      // Adicionar esse menu somente para os colabs porque não o
      // "DashOnline" nem "DashRetail"
      if (this.isCollaborator) {
        this.dashboard = this.items.children.find((item) => {
          if (item.meta.nameDrawer === "Dashboard") {
            return item;
          }
        });
      }
    },
    showBetDialog(betNumber) {
      this.disableSearch = true;
      this.$bet.showBetDialog(betNumber);
      setTimeout(() => {
        this.disableSearch = false;
      }, 2000);
    },
    consultBet: async function(e) {
      e.preventDefault();
      const data = { domain: localStorage.operator, id_bet: this.betNumber };
      const request = await this.$request.post(
        `${localStorage.level}/bets/getBetAgent`,
        data
      );
      this.dataConsultBet = request.dados;
    },
    setMenusCollaborator() {
      let onlineItems = [];
      let networkItems = [];
      let operationItems = [];

      this.items.children.forEach((item) => {
        if (item.name === "CollaboratorAccount") {
          operationItems.push({ ...item, idMenu: 11 });
          return;
        }

        if (!(item.name == "CollaboratorDashboard")) {
          const { permissions } = JSON.parse(localStorage.getItem("user_data"));

          permissions.forEach((permission) => {
            if (item.meta.permissions.includes(permission.permissions)) {
              if (item.drawerLevel === "online") {
                // Se não tiver permissão de Lista de Apostas de Cassino setar
                // meta "group" de "CollaboratorBets" para false
                if (!this.$permission("41")) {
                  if (
                    onlineItems[0] &&
                    onlineItems[0].name === "CollaboratorBets"
                  ) {
                    onlineItems[0].meta.group = false;
                  }
                }

                if (
                  !onlineItems.find((item) => item.idMenu == permission.id_menu)
                ) {
                  onlineItems.push({ ...item, idMenu: permission.id_menu });
                }
              } else if (item.drawerLevel === "network") {
                if (
                  !networkItems.find(
                    (item) => item.idMenu == permission.id_menu
                  )
                ) {
                  networkItems.push({ ...item, idMenu: permission.id_menu });
                }
              } else {
                if (
                  !operationItems.find(
                    (item) => item.idMenu == permission.id_menu
                  )
                ) {
                  operationItems.push({ ...item, idMenu: permission.id_menu });
                }
              }
            }
          });
        }
      });

      let shouldHideOperation = true;

      // Esconde rotas aninhadas
      operationItems.forEach((item) => {
        if (item.name === "CollaboratorAccount") {
          return;
        }

        item.children.forEach((children) => {
          // Esconder menu operação quando nenhuma permissão for encontrada
          const user_data = localStorage.getItem("user_data");
          const permissions = JSON.parse(user_data).permissions;
          permissions.forEach((permission) => {
            if (
              Array.isArray(children.children) &&
              children.meta.permissions.includes(permission.permissions)
            ) {
              shouldHideOperation = false;
            }
          });

          // Esconder rotas aninhadas
          if (
            Array.isArray(children.children) &&
            Array.isArray(children.children).length > 0
          ) {
            let newChildren = [];
            children.children.forEach((_children) => {
              if (this.$permission(_children.meta.permission)) {
                newChildren.push(_children);
              }
            });
            children.children = newChildren;
            if (newChildren.length == 0) {
              let newChildren = [];
              for (let _children of item.children) {
                if (_children.name != children.name) {
                  newChildren.push(_children);
                }
              }
              item.children = newChildren;
            }
          } else {
            // Caso queira mostrar rotas aninhadas
            let showMenu = children.meta.showMenu;
            if (showMenu && this.$permission(children.meta.permission)) {
              return;
            }

            let hideMenu = true;
            children.meta.permissions &&
              children.meta.permissions.forEach((permission) => {
                if (this.$permission(permission)) {
                  hideMenu = false;
                }
              });

            if (hideMenu) {
              let newChildren = [];
              for (let _children of item.children) {
                if (_children.name != children.name) {
                  newChildren.push(_children);
                }
              }
              item.children = newChildren;
            }
          }
        });
      });

      if (
        shouldHideOperation &&
        operationItems.find((item) => item.children.length === 0)
      ) {
        operationItems = [];
      }

      this.showOnline = onlineItems.length > 0;
      this.showNetwork = networkItems.length > 0;
      this.showOperation = operationItems.length > 0;

      this.onlineItems = onlineItems;
      this.networkItems = networkItems;
      this.operationItems = operationItems;
    },
  },
};
</script>
